
<!-- start header  -->
<header>
  <app-head (newItemEvent)="addItem($event)" [titleModule]="'Apartments'"></app-head>
</header>
<!-- end header  -->

<div class="row m-0 CCCCFSMILY">
  <!-- start sidebar  -->
  <app-sidebar class="col-lg-2" [showSide]="showSide" [titlepage]="'apartments'"></app-sidebar>
  <!-- end sidebar  -->
  <!-- start content page  -->
  <main class="p-4 col-lg-10 ">

<div class="bg-white p-3">
  <!--Backup information-->
  <div>
    <p class="fw-bold mb-0">Backup information</p>
    <p class="gray">Add backup information to your property.</p>
  </div>
  <p-toast></p-toast>

 
     
    <div>
      <div class="card flex justify-center mt-3">
        <p-accordion>
          <p-accordionTab>
            <ng-template pTemplate="header">
              <div>
                <img
                  class="me-2"
                  src="/assets/images/KitchenIcon.svg"
                  alt="KitchenIcon"
                />
                <span style="color: #0a0c0f; font-size: 16px; font-weight: 500"
                  >Kitchen</span
                >
              </div>
            </ng-template>

            <!---------------------------------------------------------------------------------------->
            <div>
              <!-------------------------------------------------------------------------->

              <!-- <div class="row">
                 

                <div>
                    <div class="position-relative h-124px mb-3">
                     
                        <ng-container>
                            <input type="file" accept="image/*" multiple="multiple" (change)="selectFile($event)" class="ng-star-inserted d-block w-100 h-124px file position-absolute">
                            <img src="assets/images/apartmentImages/_File upload base.svg" class="position-absolute" width="100%">
                        </ng-container>

                      
                    </div>
                </div>
            </div>
      
            <div class="card1">
                <div class="row">
                    <div class="col-md-2 card33" *ngFor="let image of apt_imgs;  index as i ">
                        <a (click)="removeItem(image)" style="      border: none;   margin-bottom: 10px; position: absolute;">
                            <img class="imageRemove" src="../../../../../../assets/images/delete.svg" width="32px" height="32px;">
                        </a>
                       
                        <a (click)="opencloseModal(image)">
                            <img [src]="image" alt="Avatar" style="width:339px;height:205px ;" class="cursor">
                        </a>

                    </div>
                </div>
            
                <div class="row" *ngIf="storedImages!=null||storedImages!=''">
                    <div class="col-md-2 card33" *ngFor="let image of storedImages;  index as i ">

                        <a (click)="opencloseModal(image)">
                            <img [src]="image" alt="Avatar" style="width:339px;height:205px ; " class="cursor">

                        </a>

                    </div>
                </div>
                <div class="row" *ngIf="edit=='EditForm'">
                    <div class="col-md-2 card33" *ngFor="let image of aprt_details_Edit?.apartment_Damages_Imgs;  index as i ">

                        <a (click)="opencloseModal(image)">
                            <img [src]="image" alt="Avatar" style="width:339px;height:205px ; " class="cursor">

                        </a>

                    </div>
                </div>
            </div> -->

              <!------------------------>
              <app-upload-file
                label="Kitchen Photos"
                [(images)]="kitchenPhotos"
              >
              </app-upload-file>

              <!-------------------------------------------------->
            </div>

            <!----------------------Question--------------------------------------------------->
            <!-- Questions -->
            <div *ngFor="let question of roomQuestions.kitchen; let i = index">
              <p class="fw-bold">{{ question.question }}</p>
              <div>
                <input
                  type="radio"
                   [name]="'k_q' + i"
                   [checked]="(question.answer || '').toString().toLowerCase() === 'yes'"
                  (change)="question.answer = 'yes'"
                />
                Yes
              </div>
              <div>
                <input
                  type="radio"
                  [name]="'k_q' + i"
                  [checked]="(question.answer || '').toString().toLowerCase() === 'no'"

                  (change)="question.answer = 'no'"
                />
                No, I want to report a problem
              </div>

              <!-- بعد خيارات Yes/No ونص التعليق -->
              <div *ngIf="question?.__invalid" class="text-danger small mt-1">
                This question is required. If you choose "No", please add a comment or at least one photo.
              </div>


              <div *ngIf="question.answer === 'yes'">
                <textarea
                  [(ngModel)]="question.comment"
                  [ngModelOptions]="{standalone: true}"
                  placeholder="Optional Comment"
                  rows="3"
                  class="form-control mt-2"
                ></textarea>
              </div>

              <div *ngIf="question.answer === 'no'" class="photo-card mt-3">
                <app-upload-file
                  [label]="question.id"
                  [(images)]="question.images"
                ></app-upload-file>

                <textarea
                  [(ngModel)]="question.comment"
                  [ngModelOptions]="{standalone: true}"
                  class="form-control mt-2"
                  placeholder="Describe the issue..."
                  rows="4"
                ></textarea>
              </div>

              <hr class="my-4" />
            </div>
            <!---------->
          </p-accordionTab>

          <p-accordionTab>
            <ng-template pTemplate="header">
              <div>
                <img
                  class="me-2"
                  src="/assets/images/bathIcon.svg"
                  alt="KitchenIcon"
                />
                <span style="color: #0a0c0f; font-size: 16px; font-weight: 500"
                  >Bathroom</span
                >
              </div>
            </ng-template>
            <div>
              <app-upload-file
                label="Bathroom Photos"
                [(images)]="bathroomPhotos"
              >
              </app-upload-file>
            </div>

            <!----------------------Question--------------------------------------------------->
            <!-- Questions -->
            <div *ngFor="let question of roomQuestions.bathroom; let i = index">
              <p class="fw-bold">{{ question.question }}</p>
              <div>
                <input
                  type="radio"
                  [name]="'b_q' + i"
                   [checked]="(question.answer || '').toString().toLowerCase() === 'yes'"
                  (change)="question.answer = 'yes'"
                />
                Yes
              </div>
              <div>
                <input
                  type="radio"
                  [name]="'b_q' + i"
                  [checked]="(question.answer || '').toString().toLowerCase() === 'no'"
                  (change)="question.answer = 'no'"
                />
                No, I want to report a problem
              </div>

               <!-- بعد خيارات Yes/No ونص التعليق -->
              <div *ngIf="question?.__invalid" class="text-danger small mt-1">
                This question is required. If you choose "No", please add a comment or at least one photo.
              </div>

              <div *ngIf="question.answer === 'yes'">
                <textarea
                  [(ngModel)]="question.comment"
                  [ngModelOptions]="{standalone: true}"
                  placeholder="Optional Comment"
                  rows="3"
                  class="form-control mt-2"
                ></textarea>
              </div>

              <div *ngIf="question.answer === 'no'" class="photo-card mt-3">
                <app-upload-file
                  [label]="question.id"
                  [(images)]="question.images"
                ></app-upload-file>

                <textarea
                  [(ngModel)]="question.comment"
                  [ngModelOptions]="{standalone: true}"
                  class="form-control mt-2"
                  placeholder="Describe the issue..."
                  rows="4"
                ></textarea>
              </div>

              <hr class="my-4" />
            </div>
          </p-accordionTab>

          <p-accordionTab>
            <ng-template pTemplate="header">
              <div>
                <img
                  class="me-2"
                  src="/assets/images/livingIcon.svg"
                  alt="KitchenIcon"
                />
                <span style="color: #0a0c0f; font-size: 16px; font-weight: 500"
                  >Living Room</span
                >
              </div>
            </ng-template>
            <div>
              <app-upload-file
                label="Bedroom 1 Photos"
                [(images)]="livingRoomPhotos"
              >
              </app-upload-file>
            </div>

            <!----------------------Question--------------------------------------------------->
            <!-- Questions -->
            <div
              *ngFor="let question of roomQuestions.livingRoom; let i = index"
            >
              <p class="fw-bold">{{ question.question }}</p>
              <div>
                <input
                  type="radio"
                  [name]="'l_q' + i"
                   [checked]="(question.answer || '').toString().toLowerCase() === 'yes'"
                  (change)="question.answer = 'yes'"
                />
                Yes
              </div>
              <div>
                <input
                  type="radio"
                  [name]="'l_q' + i"
                  [checked]="(question.answer || '').toString().toLowerCase() === 'no'"
                  (change)="question.answer = 'no'"
                />
                No, I want to report a problem
              </div>

               <!-- بعد خيارات Yes/No ونص التعليق -->
              <div *ngIf="question?.__invalid" class="text-danger small mt-1">
                This question is required. If you choose "No", please add a comment or at least one photo.
              </div>

              <div *ngIf="question.answer === 'yes'">
                <textarea
                  [(ngModel)]="question.comment"
                  [ngModelOptions]="{standalone: true}"
                  placeholder="Optional Comment"
                  rows="3"
                  class="form-control mt-2"
                ></textarea>
              </div>

              <div
                *ngIf="question.answer === 'no'"
                class="photo-card mt-3 border"
              >
                <app-upload-file
                  [label]="question.id"
                  [(images)]="question.images"
                ></app-upload-file>

                <textarea
                  [(ngModel)]="question.comment"
                  [ngModelOptions]="{standalone: true}"
                  class="form-control mt-2"
                  placeholder="Describe the issue..."
                  rows="4"
                ></textarea>
              </div>

              <hr class="my-4" />
            </div>
          </p-accordionTab>

          <p-accordionTab>
            <ng-template pTemplate="header">
              <div>
                <img
                  class="me-2"
                  src="/assets/bedroomIcon.svg"
                  alt="KitchenIcon"
                />
                <span style="color: #0a0c0f; font-size: 16px; font-weight: 500"
                  >Bedrooms</span
                >
              </div>
            </ng-template>
            <p-accordion *ngIf="getbedrooms.length">
              <p-accordionTab *ngFor="let room of getbedrooms">
                <ng-template pTemplate="header">
                  Bedroom ({{ room.room_Name }})
                </ng-template>

                <app-upload-file
                  [label]="room.room_Name + ' Photos'"
                  [(images)]="room.place_Images"
                ></app-upload-file>

                <div
                  *ngFor="
                    let question of room.questions;
                    let qIndex = index
                  "
                >
                  <p class="fw-bold">{{ question.question }}</p>

                  <div>
                    <input
                      type="radio"
                      [name]="room.room_ID + '_q' + qIndex"
                       [checked]="(question.answer || '').toString().toLowerCase() === 'yes'"
                      (change)="question.answer = 'yes'"
                    />
                    Yes
                  </div>
                  <div>
                    <input
                      type="radio"
                      [name]="room.room_ID + '_q' + qIndex"
                      [checked]="(question.answer || '').toString().toLowerCase() === 'no'"
                      (change)="question.answer = 'no'"
                    />
                    No, I want to report a problem
                  </div>


                   <!-- بعد خيارات Yes/No ونص التعليق -->
              <div *ngIf="question?.__invalid" class="text-danger small mt-1">
                This question is required. If you choose "No", please add a comment or at least one photo.
              </div>

                  <div *ngIf="question.answer === 'yes'">
                    <textarea
                      [(ngModel)]="question.comment"
                      [ngModelOptions]="{standalone: true}"
                      class="form-control mt-2"
                      placeholder="Optional Comment"
                      rows="3"
                    ></textarea>
                  </div>

                  <div
                    *ngIf="question.answer === 'no'"
                    class="photo-card mt-3 border"
                  >
                    <app-upload-file
                      [label]="question.id"
                      [(images)]="question.images"
                    ></app-upload-file>

                    <textarea
                      [(ngModel)]="question.comment"
                      [ngModelOptions]="{standalone: true}"
                      class="form-control mt-2"
                      placeholder="Describe the issue..."
                      rows="4"
                    ></textarea>
                  </div>

                  <hr class="my-4" />
                </div>
              </p-accordionTab>
            </p-accordion>
          </p-accordionTab>

          <!------------------------------------------------------------------------------->
        </p-accordion>

        <!----------test-->
        <button
          type="button"
          class="rounded-2 text-white outline-0 border-0 rounded-2 py-2 px-4"
          style="background-color: #1f4068 !important"
          (click)="submitHandover()"
        >
          Submit Handover Sections
        </button>

        <!--------------->
      </div>
    </div>
    <!---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------->
 
 
     
 
</div>

</main>
</div>

 
